module.exports = __webpack_public_path__ + "img/home1_biaoshi.ff3f3d62.png";